import { useState, useLayoutEffect } from "react";
import { Button, InputLabel } from "@mui/material";

import PhoneInputWithCountry from "../ui/PhoneInputWithCountry";
import { getOtpRequestCooldownMessage, isOtpRequestCooldownError, requestOtp, stampOtpSessionData } from "../../services/otp";
import { emitSnackbar } from "../../lib/snackbar-emitter";
import manageErrors from "../../lib/error-management";
import { isAuthenticated } from "../../services/auth";
import { useNavigate } from "react-router-dom";
interface Step1Props {
  onNext: () => void;
  goBack: () => void;
  setSession: (session_data: any) => void;
}

export let requestSession: () => Promise<void> = () => Promise.resolve()

const LoginScreen = ({ onNext, setSession, goBack }: Step1Props) => {
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  useLayoutEffect(()=>{
      if (isAuthenticated()){
          navigate('/home')
  }}, [navigate])

  const isValid = phone.replace(/\D/g, "").length >= 10;

  const submit = async () => {
      setLoading(true)
      const response = await requestOtp({telephone:phone, login: true})
      if (response.status === 200){
        const data = stampOtpSessionData(response.data, phone)
        setSession(data)
        onNext()
      } 
      else if (isOtpRequestCooldownError(response))
        emitSnackbar({message: getOtpRequestCooldownMessage(null, phone), severity: 'warning'})
      else 
        emitSnackbar({message: manageErrors(response.data), severity: 'error'})
      setLoading(false)
  }

  requestSession = submit

  return (
    <div className="w-full max-w-lg mx-auto">
      <div className="text-center mb-8">
        <h1 className="text-xl font-bold text-foreground mb-2">
          Bem-vindo de volta!
        </h1>

      </div>

      <div className="bg-card rounded-lg border border-border shadow-sm p-6 space-y-5">
        
        <div className="space-y-1.5">
          <InputLabel htmlFor="phone" className="text-sm font-medium text-foreground">Número do whatsapp</InputLabel>
          <PhoneInputWithCountry
            id="phone"
            value={phone}
            onChange={setPhone} />

          <p className="text-xs text-muted-foreground">
            Usaremos este número para enviar seu token de acesso seguro.
          </p>
        </div>
        <Button
          className="w-full"
          size="large"
          disabled={!isValid || loading}
          variant='contained'
          onClick={submit}>

        {loading ? 'Aguarde':'Continuar'}  
        </Button>

        <p className="text-center">
          <button type="button" className="text-sm font-medium text-accent hover:underline bg-transparent border-none p-0 cursor-pointer"
            onClick={goBack}
          >
            Não tenho conta! Cadastrar.
          </button>
        </p>
      </div>
    </div>);

};

export default LoginScreen;